// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  voteId: __t.u64().primaryKey().name("vote_id"),
  billId: __t.u64().name("bill_id"),
  settlementId: __t.u64().name("settlement_id"),
  aye: __t.bool(),
  votes: __t.i32(),
  population: __t.i32(),
});
